window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch) ||
        window.navigator.maxTouchPoints ||
        window.navigator.msMaxTouchPoints ?
        true :
        false,
    stickyHeader: false,
    rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};
theme.recentlyViewedIds = [];

(function() {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    new theme.HeaderCart();
    let phsp;
    if (document.body.classList.contains("template-product")) {
        // new theme.Sections();
        new theme.AjaxProduct();
        phsp = new theme.Photoswipe();
    }
    if (document.getElementById("product-grid")) {
        // new theme.QuickAdd(document.getElementById('product-grid'));
    }

    let sliders = document.querySelectorAll(".grid-product-slider");
    if (sliders) {
        sliders.forEach((item) => {
            new theme.QuickAdd(item);
        });
    }

    let slidersSwiper = document.querySelectorAll(".swiper-collection");
    if (slidersSwiper) {
        slidersSwiper.forEach((item) => {
            new theme.QuickAdd(item);
        });
    }

    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
        connectedCallback() {
            document.documentElement.addEventListener(
                "cart:updated",
                this._onCartUpdated.bind(this)
            );
        }
        get threshold() {
            return parseFloat(this.getAttribute("threshold"));
        }
        _onCartUpdated(event) {
            this.style.setProperty(
                "--progress",
                Math.min(
                    parseFloat(event.detail["cart"]["total_price"]) / this.threshold,
                    1
                )
            );
        }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    // js/custom-element/section/cart/free-shipping-bar.js

    function loadRecentlyProducts(theme) {
        var recentIds = window.localStorage.getItem("recently-viewed");
        if (recentIds && typeof recentIds !== undefined) {
            theme.recentlyViewedIds = JSON.parse(recentIds);
        }

        // Stop if no data
        let container = document.querySelector(
            '[data-section-type="recently-viewed"]'
        );
        if (container && !theme.recentlyViewedIds.length) {
            container.classList.add("hide");
            return;
        }

        this.outputContainer = document.getElementById("RecentlyViewed");

        if (!this.outputContainer) return false;
        // var currentId = this.container.getAttribute('data-product-id');

        var url = "/search?view=recently-viewed&type=product&q=";

        var products = "";
        var i = 0;
        let maxProducts = 5;
        theme.recentlyViewedIds.forEach(function(val) {
            // Skip current product
            // if (val === currentId) {
            //   return;
            // }

            // Stop at max
            if (i >= maxProducts) {
                return;
            }

            products += "id:" + val + " OR ";
            i++;
        });

        url = url + encodeURIComponent(products);

        fetch(url)
            .then(function(response) {
                return response.text();
            })
            .then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var count = doc.querySelectorAll(".product-grid").length;
                // let containerOut = document.getElementById('RecentlyViewed');
                if (count > 0) {
                    var results = doc.querySelector(".product-grid");
                    this.outputContainer.append(results);
                    // new theme.QuickAdd(this.outputContainer);
                    container.classList.remove("hide");
                } else {
                    this.outputContainer.classList.add("hide");
                }
            });
    }
    loadRecentlyProducts(theme);

    function setRecentlyProducts(theme) {
        var productCurrent = document.querySelector('[name="product-id"]');
        theme.recentlyViewedIds.forEach(function(val) {
            if (val === null) {
                theme.recentlyViewedIds = [];
            }
        });
        if (!productCurrent) return false;
        let id = productCurrent.value;

        if (!id) return;

        // Remove current product if already in recently viewed array
        var i = theme.recentlyViewedIds.indexOf(id);
        if (i > -1) {
            theme.recentlyViewedIds.splice(i, 1);
        }

        theme.recentlyViewedIds.unshift(id);
        if (theme.recentlyViewedIds.length > 5) {
            theme.recentlyViewedIds.length = 5;
        }

        // theme.recentlyViewedIds = theme.recentlyViewedIds.slice(1,6);

        if (theme.config.hasLocalStorage) {
            window.localStorage.setItem(
                "recently-viewed",
                JSON.stringify(theme.recentlyViewedIds)
            );
        }
    }
    setRecentlyProducts(theme);
})();

(function($) {
    $(document).ready(function() {
      
        $("body").on("click", ".continue_shop", function(e) {
            e.preventDefault();
            $(".js-close-header-cart").trigger("click");
        });

        $(".faq_block_container .faq_title").on("click", function(e) {
            e.preventDefault();
            if ($(this).hasClass("active")) {
                $(this).siblings(".content").hide("slow");
                $(this).removeClass("active");
            } else {
                $(this).siblings(".content").show("slow");
                $(this).addClass("active");
            }
        });

       

        // Language selector
        $(document).ready(function() {
            $(".gt_switcher div.gt_selected").on("click", function(evt) {
                const gt_switcher = evt.currentTarget.closest(".gt_switcher");

                if (!gt_switcher) return;

                const gt_option = gt_switcher.querySelector(".gt_option");

                if (!gt_option) return;

                window.setTimeout(function() {
                    gt_option.style.transform = `translateY(-107px) scaleY(${
            gt_option.style.transform === "translateY(-107px) scaleY(1)" ? 0 : 1
          })`;
                }, 200);
            });
        });

        $(document).on("click", function() {
            const gt_option = document.querySelector(".gt_switcher .gt_option");

            if (!gt_option) return;

            gt_option.style.transform = `translateY(-107px) scaleY(0)`;
        });

        /**
         * change looks for product collection page
         */
        $("body").on("click", "button[data-view]", function(e) {
            e.preventDefault();
            $("button[data-view]").removeClass("is-active");
            $(this).addClass("is-active");
            let view = $(this).attr("data-view");
            $("#product-grid").attr("data-view", view);
        });

        function setSlideHeight(that) {
            $(".gallery-thumbs").css({
                height: "auto"
            });
            var currentSlide = that.activeIndex;
            var newHeight = $(that.slides[currentSlide]).height();

            $(".gallery-thumbs .swiper-wrapper,.gallery-thumbs .swiper-slide").css({
                height: newHeight,
            });
            that.update();
        }

        function isVideoPlay(that) {
            // console.log("isvideoplayer");
            if (
                $(".gallery-main .swiper-slide-active .deferred-media__poster").length >
                0
            ) {
                $(".gallery-main .swiper-slide-active .deferred-media__poster").trigger(
                    "click"
                );
            }
            if ($(".gallery-main .swiper-slide-active video").length > 0) {
                let video = $(".gallery-main .swiper-slide-active video");

                try {
                    video[0].play();
                } catch (error) {
                    console.log(error);
                }
            }
        }
        var galleryThumbs, galleryMain;
        /*
         * slider swiper for single product page
         */
        if ($(window).width() > 750) {
            let slides = $(".gallery-main .product__media-item");
            if ($(".gallery-main .product__media-item").length > 1) {
                galleryThumbs = new Swiper(".gallery-thumbs", {
                    slidesPerView: 4,
                    watchOverflow: false,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    direction: "vertical",
                    navigation: {
                        nextEl: ".gallery-swiper-button-next",
                        prevEl: ".gallery-swiper-button-prev",
                    },
                    initialSlide: 1,
                    autoScrollOffset: 1,
                    spaceBetween: 10,
                    slideToClickedSlide: true,
                    on: {
                        init: function() {
                            setSlideHeight(this);
                        },
                        slideChangeTransitionEnd: function() {
                            setSlideHeight(this);
                        },
                    },
                });
                $(".slider-thumbnail").show();
                galleryMain = new Swiper(".gallery-main", {
                    slideToClickedSlide: true,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    thumbs: {
                        swiper: galleryThumbs,
                    },
                    on: {
                        slideChangeTransitionEnd: function() {
                            isVideoPlay(this);
                        },
                    },
                });
                galleryMain.on("slideChangeTransitionStart", function() {
                    galleryThumbs.slideTo(galleryMain.activeIndex);
                });

                galleryThumbs.on("transitionStart", function() {
                    galleryMain.slideTo(galleryThumbs.activeIndex);
                });
                let thumbSliders = document.querySelectorAll(
                    ".gallery-thumbs .swiper-slide"
                );
                thumbSliders.forEach((elem) => {
                    elem.addEventListener("mouseenter", () => {
                        const index = parseInt(
                            elem.getAttribute("data-media-position"),
                            10
                        );
                        // galleryThumbs.slideTo(index);
                        galleryMain.slideTo(index - 1, 1000, false);
                        // galleryThumbs.slideTo(index - 1, 1000, false);
                    });
                });
            } else {
                $(".gallery-thumbs .swiper-wrapper").removeClass("swiper-wrapper");
                $(".gallery-thumbs .swiper-button-prev").remove();
                $(".gallery-thumbs .swiper-button-next").remove();
                $(".gallery-thumbs .swiper-pagination").remove();
                $(".gallery-thumbs .swiper-container").removeClass("swiper-container");
            }
        } else {
            if ($(".gallery-main .product__media-item").length > 1) {
                galleryMain = new Swiper(".gallery-main", {
                    // loop: true,
                    loopedSlides: 3,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    slideToClickedSlide: true,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    thumbs: {
                        swiper: galleryThumbs,
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    on: {
                        slideChangeTransitionEnd: function() {
                            isVideoPlay(this);
                        },
                    },
                });
            } else {
                $(".gallery-main .swiper-wrapper").removeClass("swiper-wrapper");
                $(".gallery-main.swiper-container").removeClass("swiper-container");
                $(".gallery-main .swiper-button-prev").remove();
                $(".gallery-main .swiper-button-next").remove();
                $(".gallery-main .swiper-pagination").remove();
            }
        }

        if ($('.template-product [name="Color"]:checked').length > 0) {
            let currentVariant = $('[name="Color"]:checked').val();
            $("variant-radios .product-form__input .current_color").text(
                currentVariant
            );
        }

        /**
         * code for change slides in product slide for each variant
         */
        let productCur = $("[data-tb-variants-json]").attr("data-tb-variants-json");
        if (productCur) {
            productCur = JSON.parse(productCur);
        }
function variantImage(val) {
  if (!productCur) { console.log('productCur חסר'); return; }
  
  const variant = productCur.find((v) => v.option1 === val);
  console.log('val:', val, 'variant:', variant);
  
  if (!variant) { console.log('לא נמצא וריאנט עבור:', val); return; }
  if (!variant.featured_media) { console.log('אין featured_media לוריאנט'); return; }
  
  const mediaId = variant.featured_media.id;
  const targetSlide = document.querySelector(`[date-for-slick="${mediaId}"]`);
  console.log('mediaId:', mediaId, 'targetSlide:', targetSlide, 'galleryMain:', galleryMain);
  
  if (!targetSlide) return;
  if (galleryMain) {
    const slides = Array.from(document.querySelectorAll('.gallery-main .swiper-slide'));
    const index = slides.indexOf(targetSlide);
    console.log('index:', index);
    if (index !== -1) {
      galleryMain.slideTo(index);
    }
  }
}

        $("body").on("change", '[name="Color"]', function() {
            let currentVariant = $(this)
                .closest("variant-radios")
                .find('[name="Color"]:checked')
                .val();
            $(this)
                .closest("variant-radios")
                .find(".product-form__input .current_color")
                .text(currentVariant);
            $(this)
                .closest("product-info")
                .find(".product-form__input .label_active_button")
                .text(currentVariant);
            var selectedVariantId = $(this).val();
            variantImage(selectedVariantId);
        });

        $("body").on("change", '[name="color"]', function() {
            let currentVariant = $(this)
                .closest("variant-radios")
                .find('[name="color"]:checked')
                .val();
            $(this)
                .closest("variant-radios")
                .find(".product-form__input .current_color")
                .text(currentVariant);
            $(this)
                .closest("product-info")
                .find(".product-form__input .label_active_button")
                .text(currentVariant);
            var selectedVariantId = $(this).val();
            variantImage(selectedVariantId);
        });

        let variatn = $('[name="Color"]:checked');
        if (variatn.length > 0) {
            var selectedVariantId = variatn.val();
            variantImage(selectedVariantId);
        }

        let variatn1 = $('[name="color"]:checked');
        if (variatn1.length > 0) {
            var selectedVariantId = variatn.val();
            variantImage(selectedVariantId);
        }

        /**
         * code for toggle sorting in mobile filter
         */
        $(".mobile-facets__sort .label_box").on("click", function(e) {
            if ($(window).width() > 750) return false;
            e.preventDefault();
            $(this).closest(".mobile-facets__sort").toggleClass("active");
        });

        let scrolledHeader = $("#SiteHeader").innerHeight() + 98;

        if (
            $(window).width() < 750 &&
            $(".facets-vertical .facets-wrapper").length > 0
        ) {
            $(".facets-vertical .facets-wrapper").css("top", scrolledHeader);
        }
        if (
            $(window).width() < 750 &&
            $(".facets-vertical .facets-wrapper").length > 0 &&
            $("menu-drawer.mobile-facets__wrapper").length > 0
        ) {
            let scrolledHeaderFilter =
                $("menu-drawer.mobile-facets__wrapper").innerHeight() + scrolledHeader;
            let activeFiltersHeight;
            if ($(".active-facets.active-facets-mobile facet-remove").length > 0) {
                activeFiltersHeight = $(
                    ".active-facets.active-facets-mobile"
                ).innerHeight();
                scrolledHeaderFilter += activeFiltersHeight;
            }
            $("#FacetFiltersFormMobile").css("top", scrolledHeaderFilter);
        }

        function checkLenghtDesc() {
            let desc = $("#collection-description-boa");
            desc.css("display", "block");
            if (desc.find("> .enlarge-text").innerHeight() > 63) {
                desc.css("display", "-webkit-box");
            } else {
                $("#collection-show-description").hide();
            }
        }
        checkLenghtDesc();

        $(".explaination").on("click", function(e) {
            e.preventDefault();
            let heightExp = $(this).find(".explanation_content");
            heightExp.css("bottom", -heightExp.innerHeight() - 10);
            $(this).toggleClass("active");
        });

        /**
         * change images in loop on hover
         */
        $(".grid-product__colors .color-swatch").on("mouseover", function() {
            let curImage = $(this).attr("data-variant-image");
            $(this)
                .closest(".grid-product")
                .find(".color_variant_img.grid-product__color-image")
                .css("backgroundImage", `url(${curImage})`)
                .addClass("is-active");
        });
        $(".grid-product__colors .color-swatch").on("mouseleave", function() {
            let curImage = $(this).attr("data-variant-image");
            $(this)
                .closest(".grid-product")
                .find(".color_variant_img.grid-product__color-image")
                .css("backgroundImage", "")
                .removeClass("is-active");
        });
        $(".grid-product__colors .color-swatch").on("click", function(e) {
            e.preventDefault();
            let newHref = $(this)
                .closest(".grid-product")
                .find(".full-unstyled-link")
                .attr("href");
            window.location.href = newHref;
        });

        // if ($('.yotpo-reviews').length > 0) {
        // $('.yotpo-reviews').slick();
        // }

        /*
         * code for fload add to cart strip
         */
        function getRealColors() {
            if (
                !(
                    document.querySelectorAll('input[name="Color"]') ||
                    document.querySelectorAll('input[name="color"]')
                )
            )
                return false;
            let container = document.querySelectorAll('input[name="Color"]');
            container = container ?
                container :
                document.querySelectorAll('input[name="color"]');
            container = container[0]?.closest(".product-form__input");
            let colors = container?.querySelectorAll(".product-form__input label");
            return colors;
        }

        function getCurrentVariant() {
            let variantObject = document.querySelector("#tb_data_div");
            variantObject = JSON.parse(
                variantObject.getAttribute("data-tb-variants-json")
            );
            let currentVariantId = document.querySelector(
                ".product-variant-id"
            ).value;
            const variant = variantObject.filter(
                (v) => v.id === parseInt(currentVariantId, 10)
            );
            return variant;
        }

        function setButtonPrice() {
            if (!document.querySelector(".sticky_bar")) return false;
            let currentVariant = getCurrentVariant();
            if (!document.querySelector(".sticky_bar .float_add_to_cart .price_add"))
                return false;
            let priceInButton = document.querySelector(
                ".sticky_bar .float_add_to_cart .price_add"
            );

            priceInButton.innerHTML =
                '<span style="margin: 0 10px;">-</span>₪' +
                currentVariant[0].price / 100;
        }
function setSku() {
  var skuEl = document.querySelector("product-info [data-sku-id]");
  if (!skuEl) return;
  try {
    let currentVariant = getCurrentVariant();
    if (currentVariant && currentVariant[0]) {
      skuEl.innerHTML = currentVariant[0].sku || '';
    }
  } catch(e) {
    console.log('setSku error:', e);
  }
}

        function setFeaturedImageFloat() {
            if (!document.querySelector(".sticky_bar")) return false;
            let currentVariant = getCurrentVariant();
            let featuredImgFloat = document.querySelector(
                ".sticky_bar .sticky_info .featured_img_float"
            );
            if (currentVariant[0].featured_image) {
                featuredImgFloat.setAttribute(
                    "src",
                    currentVariant[0].featured_image.src
                );
            } else {
                let singleImage = document.querySelector(".product__media img");
                let singleImageSrc = singleImage.getAttribute("src");
                featuredImgFloat.setAttribute("src", singleImageSrc);
            }
        }

        let variantId = document.querySelector(".product-variant-id");
        variantId?.addEventListener("change", function(e) {
            setButtonPrice();
            setFeaturedImageFloat();
            setSku();
        });

        function fakeVariantClick(e) {
            e.preventDefault();
            let a = this.querySelector(".color_item");
            let dataName = a.getAttribute("data-name");
            let allColors = document.querySelectorAll(".color_item");
            allColors.forEach((elem) => {
                elem?.closest("li")?.classList.remove("active");
            });
            this.classList.add("active");

            let realColor = document.querySelector(`input[value="${dataName}"]`);
            realColor.click();
        }

        function selectVariantsRenderProductInfo() {
            let colors = getRealColors();
            if (!colors) return false;
            const divContainer = document.createElement("div");
            divContainer.classList.add("variant-colors-select");
            const div = document.createElement("div");
            div.classList.add("colors_select_container");
            const a = document.createElement("span");
            a.classList.add("active_color");
            divContainer.appendChild(a);
            divContainer.appendChild(div);

            const ul = document.createElement("ul");
            ul.classList.add("colors_select");
            colors.forEach((color) => {
                const li = document.createElement("li");
                li.classList.add("list_color");
                const li_a = document.createElement("a");
                li_a.classList.add("color_item");
                li_a.setAttribute("href", "#");
                let colorName = color.getAttribute("data-name");
                let colorStyle = color.getAttribute("style");
                li_a.setAttribute("data-name", colorName);
                li_a.setAttribute("style", colorStyle);
                let realColor = document.querySelector(
                    `input[value="${colorName}"]:checked`
                );
                if (realColor) {
                    li.classList.add("active");
                    // li_a.classList.add('active');
                    let spanActiveColor = document.createElement("span");
                    spanActiveColor.classList.add("label_active_button");
                    spanActiveColor.textContent = colorName;

                    let spanTitleColor = document.createElement("span");
                    spanTitleColor.textContent = "גוון: ";

                    a.appendChild(spanTitleColor);
                    a.appendChild(spanActiveColor);
                }
                li_a.textContent = "";
                li.addEventListener("click", fakeVariantClick);
                li.appendChild(li_a);

                const liName = document.createElement("span");
                liName.textContent = colorName;
                li.appendChild(liName);
                ul.appendChild(li);
                div.appendChild(ul);
            });

            let productInfoElementOld = document.querySelector(
                "product-info .product-form__input"
            );
            let productInfoElement = document.querySelector(
                ".js-variants-anchor"
            );
            // productInfoElementOld.appendChild(divContainer);
            productInfoElement.appendChild(divContainer);
        }
        selectVariantsRenderProductInfo();

        function selectVariantsRender() {
            let colors = getRealColors();
            if (!colors) return false;
            const divContainer = document.createElement("div");

            const div = document.createElement("div");
            div.classList.add("colors_select_container");
            const a = document.createElement("span");
            a.setAttribute("href", "#");
            a.classList.add("active_color");
            divContainer.appendChild(a);
            divContainer.appendChild(div);

            const close = document.createElement("span");
            close.classList.add("close_toggle");
            div.appendChild(close);

            const ul = document.createElement("ul");
            ul.classList.add("colors_select");
            colors.forEach((color) => {
                const li = document.createElement("li");
                li.classList.add("list_color");
                const li_a = document.createElement("a");
                li_a.classList.add("color_item");
                li_a.setAttribute("href", "#");
                let colorName = color.getAttribute("data-name");
                let colorStyle = color.getAttribute("style");
                li_a.setAttribute("data-name", colorName);
                li_a.setAttribute("style", colorStyle);
                let realColor = document.querySelector(
                    `input[value="${colorName}"]:checked`
                );
                if (realColor) {
                    li.classList.add("active");
                    // li_a.classList.add('active');
                    let spanActiveColor = document.createElement("span");
                    spanActiveColor.classList.add("label_active_button");
                    spanActiveColor.textContent = colorName;

                    let spanTitleColor = document.createElement("span");
                    spanTitleColor.textContent = "גוון: ";

                    a.appendChild(spanTitleColor);
                    a.appendChild(spanActiveColor);
                }
                li_a.textContent = "";
                li.addEventListener("click", fakeVariantClick);
                li.appendChild(li_a);

                const liName = document.createElement("span");
                liName.textContent = colorName;
                li.appendChild(liName);
                ul.appendChild(li);
                div.appendChild(ul);
            });

            if (!document.querySelector(".sticky_bar .sticky_info")) return false;
            let parentElement = document.querySelector(".sticky_bar .sticky_info");
            parentElement.insertBefore(divContainer, parentElement.firstChild);
        }
        selectVariantsRender();

        function addToCartStripRender() {
            let colors = getRealColors();
            setButtonPrice();
            setFeaturedImageFloat();
            if (!colors) return false;

            const ul = document.createElement("ul");
            ul.classList.add("colors_filter");
            colors.forEach((color) => {
                const li = document.createElement("li");
                li.classList.add("list_color");
                const li_a = document.createElement("a");
                li_a.classList.add("color_item");
                li_a.setAttribute("href", "#");
                let colorName = color.getAttribute("data-name");
                let colorStyle = color.getAttribute("style");
                li_a.setAttribute("data-name", colorName);
                li_a.setAttribute("style", colorStyle);
                let realColor = document.querySelector(
                    `input[value="${colorName}"]:checked`
                );
                if (realColor) {
                    li.classList.add("active");
                    li_a.classList.add("active");
                }
                li_a.textContent = "";
                li.addEventListener("click", fakeVariantClick);
                li.appendChild(li_a);
                ul.appendChild(li);
            });

            // let parentElement = document.querySelector(".sticky_bar .sticky_info");
            // parentElement.insertBefore(ul, parentElement.firstChild);
        }
        let variantsObject = document.querySelector("#tb_data_div");
        if (variantsObject) {
            addToCartStripRender();
        }

        //toggler for show popup with colors
        // let activeColor = document.querySelector(".active_color");
        // activeColor?.addEventListener("click", function (e) {
        //   e.preventDefault();
        //   let toggleBlock = document.querySelector(
        //     ".sticky_bar .colors_select_container"
        //   );
        //   toggleBlock.classList.toggle("active");
        // });

        //close toggler for show popup with colors
        // let activeColorClose_toggle = document.querySelector(
        //   ".sticky_bar .close_toggle"
        // );
        // activeColorClose_toggle?.addEventListener("click", function (e) {
        //   e.preventDefault();
        //   let toggleBlock = document.querySelector(
        //     ".sticky_bar .colors_select_container"
        //   );
        //   toggleBlock.classList.toggle("active");
        // });

        let floatAddToCart = document.querySelector(".float_add_to_cart");
        floatAddToCart?.addEventListener("click", function(e) {
            e.preventDefault();

            let addToCart = document.querySelector(
                ".product-form__buttons .add-to-cart"
            );
            addToCart?.click();
        });

        /*
         * end code for fload add to cart strip
         */

        /*
         * hover animation for buttons
         */

        window.buttonAnimation = function buttonAnimation(button) {
            button.forEach((elem) => {
                elem?.addEventListener("mouseenter", (e) => {
                    const rect = elem.getBoundingClientRect();

                    const distanceTop = e.clientY - rect.top;
                    const distanceBottom = rect.bottom - e.clientY;
                    const distanceLeft = e.clientX - rect.left;
                    const distanceRight = rect.right - e.clientX;

                    const minDistance = Math.min(
                        distanceTop,
                        distanceBottom,
                        distanceLeft,
                        distanceRight
                    );

                    if (minDistance === distanceTop) {
                        elem.classList.add("hover-top");
                    } else if (minDistance === distanceBottom) {
                        elem.classList.add("hover-bottom");
                    } else if (minDistance === distanceLeft) {
                        elem.classList.add("hover-left");
                    } else if (minDistance === distanceRight) {
                        elem.classList.add("hover-right");
                    }
                });

                elem.addEventListener("mouseleave", () => {
                    elem.classList.remove(
                        "hover-top",
                        "hover-bottom",
                        "hover-left",
                        "hover-right"
                    );
                });
            });
        };

        const button = document.querySelectorAll(".float_add_to_cart");
        if (button) {
            window.buttonAnimation(button);
        }
        const cartCheckout = document.querySelectorAll(".cart__checkout");
        if (cartCheckout) {
            window.buttonAnimation(cartCheckout);
        }

        const cardButton = document.querySelectorAll(".product-form__submit-ajax");
        if (cardButton) {
            window.buttonAnimation(cardButton);
        }

        window.addEventListener("scroll", function() {
            const element = document.querySelector(".sticky_bar");
            if (!element) return false;
            if (window.scrollY > 800) {
                element.classList.add("active");
            } else {
                element.classList.remove("active");
            }
        });

        /*
         * fake close cart button
         */
        $(".CartDrawer-close").on("click", function(e) {
            e.preventDefault();
            $(".js-close-header-cart").trigger("click");
        });

        /*
         * ajax product recomendations to cart
         */
        window.addRelatedProductToCart = function(id) {
            let cartRelated = document.querySelector(
                ".cart__footer product-recommendations"
            );
            if (!cartRelated) return false;

            const currentUrl = window.location.origin;
            let relatedUrl = currentUrl + cartRelated.dataset.url;
            const urlObj = new URL(relatedUrl);
            urlObj.searchParams.set("product_id", id);
            urlObj.searchParams.set(
                "section_id",
                "template--17474741207198__related_products_swiper_qCT7cU"
            );

            relatedUrl = urlObj.toString();

            fetch(relatedUrl)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");
                    const $this = document.querySelector(
                        ".cart__footer .related-products"
                    );
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        $this.innerHTML = recommendations.innerHTML;
                        swiperInitCartRelation();
                    }

                    if (
                        html.querySelector(".grid__item") ||
                        html.querySelector(".swiper-slide")
                    ) {
                        $this.classList.add("product-recommendations--loaded");
                        // let recomendationBlock = document.querySelector(recommendations);
                    }

                    let container = document.querySelector("product-recommendations");
                    container.addEventListener("mouseover", function(event) {
                        if (event.target.matches(".product-form__submit-ajax")) {
                            window.buttonAnimation([event.target]);
                            new theme.QuickAdd(
                                document.querySelector(".cart__footer product-recommendations")
                            );
                        }
                    });
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        function swiperInitCartRelation() {
            if (document.querySelector(".cart__footer .swiper-collection")) {
                new Swiper(".cart__footer .swiper-collection", {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            }
        }

        /*
         * fake product select
         */

        let togglerVariant = document.querySelector(
            ".product-form__input .active_color"
        );

        function hideFakeSelect() {
            let toggleBlock = togglerVariant.closest(".product-form__input");
            toggleBlock.classList.remove("active");

            window.off("click.variant-select", hideFakeSelect);
        }

        togglerVariant?.addEventListener("click", function(e) {
            e.preventDefault();
            let toggleBlock = this.closest(".product-form__input");
            toggleBlock.classList.toggle("active");
            setTimeout(function() {
                window.on("click.variant-select", hideFakeSelect);
            }, 0);
        });

        /*
         * update free shipping on change subtotal price there
         */
        window.updateFreeShipping = function updateFreeShipping(subTotal) {
            let threshold = document.querySelector("free-shipping-bar[threshold]");
            let thresholdVal = parseInt(threshold.getAttribute("threshold"), 10);
            let subTotalFinally = parseInt(subTotal, 10) / thresholdVal;
            threshold.setAttribute("style", `--progress: ${subTotalFinally}`);

            // let shippingBarText = document.querySelector('free-shipping-bar .shipping-bar__text');
            // if (subTotalFinally > 1) {
            //   shippingBarText.textContent = threshold.getAttribute('data-success');
            // } else {
            //   shippingBarText.innerHTML = threshold.getAttribute('data-notenought');
            //   let valueShipping = shippingBarText.querySelector('.value');
            //   valueShipping.textContent = Math.round(thresholdVal / 100 - parseInt(subTotal, 10) / 100, 2);
            // }
        };

        /*
         *  hide header on scroll
         */
        function updateHeader() {
            let lastScrollTop = 0;
            const announcementBar = document.querySelector(".ss-announcement-bar");

            if (!announcementBar) return;

            const header = announcementBar.parentElement;

            const headerMenu = document.getElementById("HeaderWrapper");

            if (!header || !headerMenu) return;

            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > lastScrollTop && scrollTop > 200) {
                //header.style.transform = "translateY(-100%)";
                headerMenu.classList.remove("header-down");
            } else {
                //header.style.transform = "translateY(0)";
                headerMenu.classList.add("header-down");
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        }

        window.addEventListener("scroll", updateHeader);
        setTimeout(() => updateHeader(), 100);

    });
})(window.jQuery);
